var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4 cursor-pointer",on:{"click":function($event){return _vm.$router.push(`/authors/${_vm.authorUrl}`)}}},[_c('AuthorInfo',{attrs:{"author":_vm.author,"bio-text-color":"text-gray-500","is-author-page":_vm.isAuthorPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }